import React from 'react';
import ReactDOM from 'react-dom/client';

import './main.css';
import { applyThemeTokens } from '@/theme/tokens';
import i18n from '@/i18n';
import { App } from './App';

// Токены → CSS-переменные (единственный источник — src/theme/tokens.ts).
applyThemeTokens();
document.documentElement.setAttribute('lang', i18n.resolvedLanguage ?? 'ru');

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Не найден корневой элемент #root');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
